import { render, staticRenderFns } from "./zonalSection.vue?vue&type=template&id=000a310a&scoped=true"
import script from "./zonalSection.vue?vue&type=script&lang=js"
export * from "./zonalSection.vue?vue&type=script&lang=js"
import style0 from "./zonalSection.vue?vue&type=style&index=0&id=000a310a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000a310a",
  null
  
)

export default component.exports